import Vue from 'vue';
import VueRouter from 'vue-router';
import Configurator from '../views/Configurator.vue';
import MouserConfigurator from '../views/MouserConfigurator.vue';
import Configuration from '../views/Configuration.vue';
import MouserConfiguration from '../views/MouserConfiguration.vue';

Vue.use(VueRouter);

export default class {
  constructor(base) {
    const mode = 'history';
    let configuratorComponent = Configurator;
    let configurationComponent = Configuration;
    if (base.includes('mouser'))
    {
      configuratorComponent = MouserConfigurator;
      configurationComponent = MouserConfiguration;
    }
    const routes = [
      {
         path: '/',
         name: 'configurator',
         component: configuratorComponent,
      },
      {
        path: '/configuration/:product*',
        name: 'configuration',
        component: configurationComponent,
      },
      {
        path: '/configuration',
        redirect: '/',
      },
      {
        path: '/cable-builder/configuration/:product*',
        name: 'configuration-direct',
        component: Configuration,
      },
      {
          path: '/mouser-cable-builder/configuration',
          redirect: '/',
      },
      {
          path: '/mouser-cable-builder/configuration/:product',
          name: 'mouser-configuration',
          component: MouserConfiguration,
      },
      {
          path: '/mouser-cable-builder/configuration/:product',
          name: 'mouser-configuration-direct',
          component: MouserConfiguration,
      },
      
    ];
    this.router = new VueRouter({
      mode,
      base,
      routes,
    });

    return this;
  }
}
